import { useState, useEffect } from "react";
import BlogCard from "../../Blog/BlogCard";
import { BlogSlider } from "../../Blog/BlogSlider";
import BlogCardSkeleton from "../../Blog/BlogCardSkeleton";
import Flickity from "react-flickity-component";
import UseWindowSize from "src/components/UseWindowSize";
import axios from "axios";
import { env } from "src/utils/env";

type FinancialLiteracyListProps = {
  isLoadingList: boolean;
  setIsLoadingList: (boolean) => void;
  contentType: string;
  slug: string;
};

const FinancialLiteracyList = ({
  isLoadingList,
  setIsLoadingList,
  contentType,
  slug,
}: FinancialLiteracyListProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  const [financialLiteracyList, setfinancialLiteracyList] = useState(null);
  const flickityOptions = {
    contain: true,
    groupCells: winSize > 600 ? 2 : 1,
    cellAlign: "left",
    prevNextButtons: true,
    freeScroll: true,
    pageDots: false,
    draggable: true,
  };
  const getFinancialLiteracyList = async () => {
    const { status, data } = await axios.get(
      `${env.baseUrl}/api/v1/kentico/financial-literacy`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${env.auth}`,
        },
      }
    );

    if (status == 200) {
      setfinancialLiteracyList(data);
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    setWinSize(width);
    if (isLoadingList) {
      return;
    }
    setIsLoadingList(true);
    getFinancialLiteracyList();
  }, []);

  return (
    <>
      {isLoadingList && isLoadingList ? (
        <BlogSlider>
          <BlogCardSkeleton></BlogCardSkeleton>
        </BlogSlider>
      ) : (
        <Flickity
          options={flickityOptions}
          className={"carousel"}
          elementType={"div"}
        >
          {financialLiteracyList &&
            financialLiteracyList.item
              .filter(
                (data) =>
                  data.content_type === contentType &&
                  data.tags_slug.find((item) => item === slug)
              )
              .sort(
                (a, b) =>
                  new Date(b.created_date).getTime() -
                  new Date(a.created_date).getTime()
              )
              .map((data, key) => {
                const date = new Date(data.created_date);

                const formattedDate = date
                  .toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                  .replace(/, (\d{4})/, "  $1");

                return (
                  <div key={key}>
                    <BlogCard
                      key={key}
                      thumbnail={data.banner}
                      title={
                        data.title.length > 65
                          ? data.title.slice(0, 65) + "..."
                          : data.title
                      }
                      excerpt={formattedDate}
                      {...(data.link.indexOf(".") !== -1
                        ? { externalLink: data.link }
                        : { slug: data.link })}
                      slug={data.link}
                      tags={data.tags}
                    />
                  </div>
                );
              })}
        </Flickity>
      )}
      <style jsx global>{`
        .card {
          border: 1px solid #d1d1d1;
          border-radius: 10px;
        }
        .card-image {
          border-radius: 0px !important;
          border-top-right-radius: 8px !important;
          border-top-left-radius: 8px !important;
          height: 206px;
        }
        .card-content {
          padding: 0px 16px 16px;
        }
        .flickity-button-icon {
          fill: var(--color-red);
        }
        .flickity-prev-next-button {
          width: 35px;
          height: 35px;
        }
        @media only screen and (max-width: 700px) {
          .card {
            margin-top: 0px !important;
          }
          .card-image {
            height: 180px;
          }
          .flickity-viewport {
            padding: 7px;
          }
        }
      `}</style>
    </>
  );
};
export default FinancialLiteracyList;
